import { z } from "zod";
import { CommunityAuthor } from "./author.js";
// Weekly Company Recipe: one featured recipe per company per week. Admins can
// manually select a recipe or enable auto-select. Members see it in the
// community feed and their library with a "Weekly Company Recipe" badge. The
// card surfaces a slice of company-member avatars who have made it.
export const WeeklyCompanyRecipe = z.object({
    cmsUuid: z.string(),
    weekStart: z.string(),
    title: z.string(),
    summary: z.string().nullable(),
    imageUrl: z.string().nullable(),
    contentType: z.string(),
    selectedBy: CommunityAuthor.nullable(),
    autoSelected: z.boolean(),
    adminMessage: z.string().nullable(),
    makers: z.array(CommunityAuthor),
    makerCount: z.number(),
});
export const GetWeeklyCompanyRecipeResponse = z.object({
    recipe: WeeklyCompanyRecipe.nullable(),
    companyName: z.string().nullable(),
});
// Admin: select a recipe for the current (or specified) week. The optional
// `adminMessage` is shown to members in the "Why this for you" section of the
// recipe modal; null on the row means no admin message was set. The optional
// `weekStart` (YYYY-MM-DD, must be a Monday) targets a future or past week;
// omit to target the current week.
export const SelectWeeklyRecipeRequest = z.object({
    cmsUuid: z.string().min(1),
    adminMessage: z.string().max(500).optional(),
    weekStart: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, "weekStart must be YYYY-MM-DD")
        .optional(),
});
// Admin: one slot in the monthly schedule view (weekStart + optional recipe).
export const ScheduledRecipeWeek = z.object({
    weekStart: z.string(),
    recipe: WeeklyCompanyRecipe.nullable(),
});
// Admin: GET /weekly-recipe/schedule response: multiple weeks in a date range.
export const WeeklyRecipeScheduleResponse = z.object({
    weeks: z.array(ScheduledRecipeWeek),
});
// Admin: paginated recipe listing for the recipe browser.
export const RecipeListItem = z.object({
    cmsUuid: z.string(),
    title: z.string(),
    subtitle: z.string().nullable(),
    imageUrl: z.string().nullable(),
    dietaryLabels: z.array(z.string()),
    makerCount: z.number(),
    makers: z.array(CommunityAuthor),
});
export const RecipeListResponse = z.object({
    items: z.array(RecipeListItem),
    total: z.number(),
    offset: z.number(),
    limit: z.number(),
});
export const SelectWeeklyRecipeResponse = z.object({
    recipe: WeeklyCompanyRecipe,
});
// Feed item: weekly recipe surfaced as a community feed card.
export const WeeklyRecipeFeedItem = z.object({
    type: z.literal("weekly_recipe"),
    recipe: WeeklyCompanyRecipe,
});
//# sourceMappingURL=weekly-recipe.js.map